 document.addEventListener("click", function(e){
    let btn = e.target.closest(".gokwik-checkout button");
    console.log(btn);
    if(btn){
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    fetch("/cart.js")
    .then(res => {
        if (!res.ok) throw new Error("Failed to fetch cart");
        return res.json();
    })
    .then(cart => {
        if(!cart?.items?.length) return;
            recurpay.recurCart(cart);
    })
    .catch(err => {
        console.error("Cart fetch error:", err);
    });
    }
}, true);